/* eslint-disable react/no-array-index-key */
/* eslint-disable no-undef */
import React, { useState } from 'react'

import { PriceCategory } from '../../components'
import useMediaQuery from '../../hooks/useMediaQuery'
import { useTreatmentCategories } from '../../hooks/useTreatmentCategories'
import SectionLayout from '../../layouts/SectionLayout/SectionLayout'
import { ContentParser } from '../../utils/helpers'
import {
  activeCategoryContainer,
  activeTitle,
  arrowActive,
  categoryContainer,
  containerExtraClass,
  contentContainer,
  description,
  navContainer,
  navTitle,
  pricingContainer,
} from './PriceDetailsSection.module.css'

const PricingDetailsSection = ({ lang, slice }) => {
  const { pricedetailscontent, pricedetailsheading, pricedetailskicker } = slice
  const treatmentsCategoriesData = useTreatmentCategories().filter(
    (item) => item.language.slug === lang,
  )
  const { treatmentcategorycontent } = treatmentsCategoriesData[0]

  const mainCategories = ContentParser(
    treatmentcategorycontent.treatmentprimarydata,
    'category',
  )
  const treatmentAltCategories = ContentParser(
    treatmentcategorycontent,
    'treatmentcategory',
  ).filter((res) => res.treatments !== null)
  const mainAltCategories = treatmentAltCategories.filter(
    (res) => res.isundercategory === null,
  )
  const pricingCategoriesData = [mainCategories[0]].concat(mainAltCategories)
  const categories = pricingCategoriesData.map(
    (category) => category.maincategory || category.heading,
  )
  const [activeCategory, setActiveCategory] = useState(categories[0])
  const isDesktop = useMediaQuery('(min-width: 768px)')

  const handleNavClick = (category) => {
    setActiveCategory(category)
  }

  return (
    <SectionLayout
      extraDescriptionClassName={description}
      extraHeaderClassName={containerExtraClass}
      heading={pricedetailsheading}
      kicker={pricedetailskicker}
      renderedContent={pricedetailscontent}
      withHeader
    >
      <div className={contentContainer}>
        <nav className={navContainer}>
          {pricingCategoriesData.length > 0 &&
            pricingCategoriesData.map((item, idx) => {
              const title = item.maincategory || item.heading
              return (
                <React.Fragment key={idx}>
                  <li
                    className={`${navTitle} ${
                      title === activeCategory ? activeTitle : ''
                    }`}
                    onClick={() => handleNavClick(title)}
                    onKeyDown={() => handleNavClick(title)}
                    role="presentation"
                  >
                    <svg
                      className={`${
                        title === activeCategory ? arrowActive : ''
                      }`}
                      fill="none"
                      height="8"
                      style={{
                        marginRight: '8px',
                        transform:
                          title === activeCategory
                            ? 'rotate(0deg)'
                            : 'rotate(180deg)',
                        transition: 'transform 0.3s ease',
                      }}
                      viewBox="0 0 12 8"
                      width="12"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1.5L6 6.5L11 1.5"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                      />
                    </svg>
                    {/* <div
                      className={`${arrowDown} ${
                        title === activeCategory ? arrowActive : ''
                      }`}
                    /> */}
                    <span>{title}</span>
                  </li>
                </React.Fragment>
              )
            })}
        </nav>
        <div className={pricingContainer}>
          {pricingCategoriesData.length > 0 &&
            pricingCategoriesData.map((category, index) => {
              return (
                <div
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  className={`${categoryContainer} ${
                    activeCategory ===
                    (category.maincategory || category.heading)
                      ? activeCategoryContainer
                      : ''
                  }`}
                >
                  <PriceCategory
                    category={category}
                    isDesktop={isDesktop}
                    treatmentsData={treatmentAltCategories}
                  />
                </div>
              )
            })}
        </div>
      </div>
    </SectionLayout>
  )
}

export default PricingDetailsSection
